/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Operatedby_Link1Inputs */

const ja_playdata_about_operatedby_link1 = /** @type {(inputs: Playdata_About_Operatedby_Link1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`株式会社プレイブレーン`)
};

const en_playdata_about_operatedby_link1 = /** @type {(inputs: Playdata_About_Operatedby_Link1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN" |
*
* @param {Playdata_About_Operatedby_Link1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_about_operatedby_link1 = /** @type {((inputs?: Playdata_About_Operatedby_Link1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Operatedby_Link1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_operatedby_link1(inputs)
	return en_playdata_about_operatedby_link1(inputs)
});
export { playdata_about_operatedby_link1 as "playdata_about_operatedBy_link" }